import React from 'react';
import LanguageSelectTrigger from './LanguageSelectTrigger';
import LanguageSelectModal from './LanguageSelectModal';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useTypedDispatch } from '../../Hooks/useTypedDispatch';
import { channelPicker } from '../../Reducers/ChannelPicker.reducer';

const LanguageSelectDesktopContainer = () => {
  const { open } = useTypedSelector((state) => state.channelPicker);
  const dispatch = useTypedDispatch();

  return (
    <div className="relative store-screen:hidden">
      <LanguageSelectTrigger
        onClick={() => dispatch(channelPicker.setOpen(!open))}
        languageSelectActive={open}
      />
      {open && (
        <div className="absolute left-[50%] w-[268px] translate-x-[-50%] rounded bg-white shadow-[0px_13px_37px_0px_rgba(0,0,0,0.21)]">
          <LanguageSelectModal />
        </div>
      )}
    </div>
  );
};

export default LanguageSelectDesktopContainer;
